import createHistory from "history/createBrowserHistory";
import React from "react";
import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import Dashboard from "modules/dashboard/Dashboard";
import PushApp from "modules/exams/push-app/push-app";
import Login from "modules/authentication/login";
import AddQuestion from "modules/dashboard/AddQuestion";
import CopyExam from "modules/exams/copy-exam/copy-exam";
import ExamsInfo from "modules/exams/exams-info/exams-info";
import ForgotPassword from "modules/authentication/forgot";
import { TakeExam } from "modules/exams/take-exam/takeexam";
import { RouteWithSubRoutes } from "modules/service/common";
import QuestionBank from "modules/question-bank/QuestionBank";
import UploadQuestion from "modules/dashboard/UploadQuestion";
import CreateExam from "modules/exams/create-exam/create-exam";
import BaseApp from "modules/platform-components/base-app/BaseApp";
import Administration from "modules/administration/administration";
import { getUserDetails } from "modules/platform-components/utils/shared-data.service";
import ChangePassword from "modules/authentication/change-password";
import Classes from "modules/classes";
import ZoomMeeting from "modules/zoom";
import WowzaMeeting from "modules/wowza";
import Feedback from "modules/feedback/feedback";
import Qb from "modules/qb/qb";
import Tests from "modules/tests/tests";
import Users from "modules/userManagement/users/Users";
import Roles from "modules/userManagement/roles/Roles";

const history = createHistory();

const isAuthenticated = () => {
  return getUserDetails().email ? true : false;
};

export const permissions: any = {
  "Question Creator": {
    addQuestion: true,
    editQuestion: true,
    deleteQuestion: true,
    sendForApproval: true,
  },
  "Question Approver": {
    approve: true,
    addQuestion: true,
    correctionNeeded: true,
    rejected: true,
    deleteQuestion: true,
    sendForApproval: true,
  },
  "Exam Creator": {
    createExam: true,
    copyExam: true,
    sendForApproval: true,
    editExam: true,
    deleteExam: true,
    download: true,
  },
  "Exam Approver": {
    approve: true,
    download: true,
  },
};
export const examineeRoutes = [
  {
    path: "/app/dashboard",
    component: isAuthenticated() ? Dashboard : <Redirect to="/login" />,
    exact: true,
    name: "Dashboard",
  },
  {
    path: "/app/exams/examsInfo",
    component: isAuthenticated() ? ExamsInfo : <Redirect to="/login" />,
    exact: true,
    name: "Exams",
    cssClass: "fa fa-book-open",
  },
  {
    path: "/app/exams/createExam",
    component: isAuthenticated() ? CreateExam : <Redirect to="/login" />,
    displayNone: true,
  },
  {
    path: "/app/exams/copyExam/:id/:examname",
    component: isAuthenticated() ? CopyExam : <Redirect to="/login" />,
    name: "Copy Exam",
    displayNone: true,
  },
  {
    path: "/app/exams/pushToApp/:id/:batchid",
    component: isAuthenticated() ? PushApp : <Redirect to="/login" />,
    name: "Push To App",
    displayNone: true,
  },
  {
    path: "/app/exams/examDetailView/:examid",
    component: isAuthenticated() ? CreateExam : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Exam Detail View",
  },
  {
    path: "/app/exams/takeorviewexam",
    component: isAuthenticated() ? TakeExam : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Take & View Exam",
  },
];
export const questionCreatorRoutes = [
  {
    path: "/app/dashboard",
    component: isAuthenticated() ? Dashboard : <Redirect to="/login" />,
    exact: true,
    name: "Dashboard",
  },
  {
    path: "/app/question/:id",
    component: isAuthenticated() ? AddQuestion : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Add Question",
  },
  {
    path: "/app/file/:type/:id",
    component: isAuthenticated() ? UploadQuestion : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Upload Question",
  },
  // {
  //   path: "/app/questionbank",
  //   component: isAuthenticated() ? QuestionBank : <Redirect to="/login" />,
  //   name: "Question Bank",
  //   cssClass: "fa fa-file-alt",
  // },
  // {
  //   path: "/app/feedback",
  //   component: isAuthenticated() ? Feedback : <Redirect to="/login" />,
  //   name: "Student Feedback",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  // {
  //   path: "/app/tests",
  //   component: isAuthenticated() ? Tests : <Redirect to="/login" />,
  //   name: "Tests",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  {
    path: "/app/qb",
    component: isAuthenticated() ? Qb : <Redirect to="/login" />,
    name: "Question Bank",
    cssClass: "fa fa-database",
    isApp: true,
  },
];
export const questionApproverRoutes = [
  {
    path: "/app/dashboard",
    component: isAuthenticated() ? Dashboard : <Redirect to="/login" />,
    exact: true,
    name: "Dashboard",
  },
  {
    path: "/app/questionbank",
    component: isAuthenticated() ? QuestionBank : <Redirect to="/login" />,
    name: "Question Repo",
    cssClass: "fa fa-archive",
  },
  // {
  //   path: "/app/feedback",
  //   component: isAuthenticated() ? Feedback : <Redirect to="/login" />,
  //   name: "Student Feedback",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  // {
  //   path: "/app/tests",
  //   component: isAuthenticated() ? Tests : <Redirect to="/login" />,
  //   name: "Tests",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  {
    path: "/app/qb",
    component: isAuthenticated() ? Qb : <Redirect to="/login" />,
    name: "Question Bank",
    cssClass: "fa fa-archive",
    isApp: true,
  },
  {
    path: "/app/question/:id",
    component: isAuthenticated() ? AddQuestion : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Add Question",
  },
  {
    path: "/app/file/:type/:id",
    component: isAuthenticated() ? UploadQuestion : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Upload Question",
  },
];
export const examCreator = [
  {
    path: "/app/exams/examsInfo",
    component: isAuthenticated() ? ExamsInfo : <Redirect to="/login" />,
    exact: true,
    name: "Exams",
    cssClass: "fa fa-book-open",
  },
  {
    path: "/app/exams/createExam",
    component: isAuthenticated() ? CreateExam : <Redirect to="/login" />,
    displayNone: true,
  },
  {
    path: "/app/exams/copyExam/:id/:examname",
    component: isAuthenticated() ? CopyExam : <Redirect to="/login" />,
    name: "Copy Exam",
    displayNone: true,
  },
  {
    path: "/app/exams/pushToApp/:id/:batchid",
    component: isAuthenticated() ? PushApp : <Redirect to="/login" />,
    name: "Push To App",
    displayNone: true,
  },
  {
    path: "/app/exams/examDetailView/:examid",
    component: isAuthenticated() ? CreateExam : <Redirect to="/login" />,
    displayNone: true,
    exact: true,
    name: "Exam Detail View",
  },
];

export const FacultyRoute = [
  {
    path: "/app/classes",
    component: isAuthenticated() ? Classes : <Redirect to="/login" />,
    name: "Classes",
    accessLevel: ["Faculty"],
  },
];

export const routes = [
  {
    path: "/",
    component: isAuthenticated() ? <Redirect to="/app/dashboard" /> : Login,
    exact: true,
  },
  {
    path: "/login",
    component: isAuthenticated() ? <Redirect to="/app/dashboard" /> : Login,
  },
  {
    path: "/app",
    component: isAuthenticated() ? BaseApp : <Redirect to="/login" />,
    routes: [
      {
        path: "/app/dashboard",
        component: isAuthenticated() ? Dashboard : <Redirect to="/login" />,
        exact: true,
        name: "Dashboard",
      },
      {
        path: "/app/questionbank",
        component: isAuthenticated() ? QuestionBank : <Redirect to="/login" />,
        name: "Question Repo",
        cssClass: "fa fa-archive",
      },
      {
        path: "/app/feedback",
        component: isAuthenticated() ? Feedback : <Redirect to="/login" />,
        name: "Student Feedback",
        cssClass: "fa fa-comments",
        isApp: true,
      },
      {
        path: "/app/tests",
        component: isAuthenticated() ? Tests : <Redirect to="/login" />,
        name: "Tests",
        cssClass: "fa fa-file-signature",
        isApp: true,
      },
      {
        path: "/app/qb",
        component: isAuthenticated() ? Qb : <Redirect to="/login" />,
        name: "Question Bank",
        cssClass: "fa fa-database",
        accessLevel: ["Exam Creator", "Exam Approver"],
        isApp: true,
      },
      {
        path: "/app/exams/examsInfo",
        component: isAuthenticated() ? ExamsInfo : <Redirect to="/login" />,
        exact: true,
        name: "Exams",
        cssClass: "fa fa-book-open",
        accessLevel: ["Exam Creator", "Exam Approver"],
      },
      {
        path: "/app/exams/createExam",
        component: isAuthenticated() ? CreateExam : <Redirect to="/login" />,
        displayNone: true,
        accessLevel: ["Exam Creator, Exam Approver"],
      },
      {
        path: "/app/exams/copyExam/:id/:examname",
        component: isAuthenticated() ? CopyExam : <Redirect to="/login" />,
        name: "Copy Exam",
        displayNone: true,
        accessLevel: ["Exam Creator, Exam Approver"],
      },
      {
        path: "/app/exams/pushToApp/:id/:batchid",
        component: isAuthenticated() ? PushApp : <Redirect to="/login" />,
        name: "Push To App",
        displayNone: true,
        accessLevel: ["Exam Approver"],
      },
      {
        path: "/app/exams/examDetailView/:examid",
        component: isAuthenticated() ? CreateExam : <Redirect to="/login" />,
        displayNone: true,
        exact: true,
        name: "Exam Detail View",
        accessLevel: ["Exam Creator", "Exam Approver"],
      },
      {
        path: "/app/question/:id",
        component: isAuthenticated() ? AddQuestion : <Redirect to="/login" />,
        displayNone: true,
        exact: true,
        name: "Add Question",
      },
      {
        path: "/app/file/:type/:id",
        component: isAuthenticated() ? (
          UploadQuestion
        ) : (
          <Redirect to="/login" />
        ),
        displayNone: true,
        exact: true,
        name: "Upload Question",
      },
      {
        path: "/app/adminPanel",
        component: isAuthenticated() ? (
          Administration
        ) : (
          <Redirect to="/login" />
        ), 
        displayNone: true,
        exact: true,
        name: "Admin",
      },
      {
        path: "/app/change-password",
        component: !isAuthenticated() ? (
          <Redirect to="/login" />
        ) : (
          ChangePassword
        ),
        displayNone: true,
        exact: true,
        name: "change",
      },
      {
        path: "/app/usersList",
        component: isAuthenticated() ? Users : <Redirect to="/login" />,
        name: "Users",
        exact: true,
        cssClass: "fa fa-user-friends",
        category: "userManagement",
      },
      {
        path: "/app/roles",
        component: isAuthenticated() ? Roles : <Redirect to="/login" />,
        name: "Roles",
        exact: true,
        cssClass: "fa fa-user-shield",
        category: "userManagement",
      },
    ],
  },
  {
    path: "/forgot-password",
    component: isAuthenticated() ? (
      <Redirect to="/app/dashboard" />
    ) : (
      ForgotPassword
    ),
  },
  {
    path: "/start-class/:id",
    component: isAuthenticated() ? ZoomMeeting : <Redirect to="/login" />,
  },
  {
    path: "/wowza/start-class/:id",
    component: isAuthenticated() ? WowzaMeeting : <Redirect to="/login" />,
  },
];

export const AppRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          {isAuthenticated() ? <Redirect to="/app/dashboard" /> : <Redirect to="/login" />}
        </Route>
        {routes.map((route) => {
          return <RouteWithSubRoutes key={route.path} {...route} />;
        })}
      </Switch>
    </Router>
  );
};
